import { api } from "./apiClient";

export const materialsAPI = {
    listByProject: (projectId) =>
        api.get(`/projects/${projectId}/materials`),

    create: (projectId, payload) =>
        api.post(`/projects/${projectId}/materials`, payload),
};
